import { render, staticRenderFns } from "./LisacomunicaLog.vue?vue&type=template&id=1dc7f183&"
import script from "./LisacomunicaLog.vue?vue&type=script&lang=js&"
export * from "./LisacomunicaLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports